var map = {
	"./en_US.ts": [
		80500,
		500
	],
	"./id_ID.ts": [
		58304,
		8304
	],
	"./ms_MY.ts": [
		45667,
		5667
	],
	"./vi_VN.ts": [
		34750,
		4750
	],
	"./zh_CN.ts": [
		29014,
		9014
	],
	"./zh_TW.ts": [
		90954,
		954
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98607;
module.exports = webpackAsyncContext;